import { Video } from "lucide-react";
import type { MediaPreview, MediaType } from "../lib/types";

interface MediaThumbProps {
  preview?: MediaPreview;
  mediaType?: MediaType;
}

export function MediaThumb({ preview, mediaType }: MediaThumbProps) {
  if (preview?.kind === "image" && preview.dataUrl) {
    return (
      <img
        src={preview.dataUrl}
        alt="Media preview"
        loading="lazy"
        className="h-14 w-14 rounded border border-line object-cover"
      />
    );
  }

  if (preview?.kind === "video" || mediaType === "video") {
    return (
      <div className="flex h-14 w-14 items-center justify-center rounded border border-line bg-slate-100 text-[11px] font-semibold text-slate-600">
        <div className="flex flex-col items-center gap-1">
          <Video size={15} />
          Video
        </div>
      </div>
    );
  }

  return <span className="text-sm text-slate-400">-</span>;
}
